import React from 'react'
import styled from 'styled-components'

const HeaderRow = styled.tr`
  background: ${({ theme }) => theme.colors.background.primary};
  height: ${({ theme }) => theme.spacing.medium};
`

const HeaderCell = styled.td`
  padding: ${({ theme }) =>
    `${theme.spacing.large} ${theme.spacing.medium} ${theme.spacing.small} ${theme.spacing.medium}`} !important;
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.tertiary};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
`

export interface MetricGroupHeaderProps {
  title: string
}

export const MetricGroupHeader: React.FC<MetricGroupHeaderProps> = ({
  title,
}) => {
  return (
    <HeaderRow>
      <HeaderCell colSpan={4}>{title}</HeaderCell>
    </HeaderRow>
  )
}
